// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const SalesOrderFulfillmentStatus = {
  ToDo: {
    Name: 'To Do',
    Value: 'to_do',
    Icon: 'SquareDashed',
    Variant: 'warning',
  },
  InProgress: {
    Name: 'In Progress',
    Value: 'in_progress',
    Icon: 'CircleEllipsis',
    Variant: 'info',
  },
  Staged: {
    Name: 'Staged',
    Value: 'staged',
    Icon: 'Package2',
    Variant: 'info',
  },
  ReadyForPickup: {
    Name: 'Ready For Pickup',
    Value: 'ready_for_pickup',
    Icon: 'PackageCheck',
    Variant: 'info',
  },
  ReadyForDelivery: {
    Name: 'Ready For Delivery',
    Value: 'ready_for_delivery',
    Icon: 'PackageCheck',
    Variant: 'info',
  },
  Out: {
    Name: 'Out',
    Value: 'out',
    Icon: 'SquareArrowRight',
    Variant: 'info',
  },
  Fulfilled: {
    Name: 'Fulfilled',
    Value: 'fulfilled',
    Icon: 'SquareCheckBig',
    Variant: 'success',
  },
} as const

export type SalesOrderFulfillmentStatusValue =
  (typeof SalesOrderFulfillmentStatus)[keyof typeof SalesOrderFulfillmentStatus]['Value']
